import { Navigate, Outlet } from "react-router-dom";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import Layout from "./-components/Layout";

export function ConsoleGuard() {
    const accessToken = useConsoleAuthStore(state => state.accessToken);

    if (!accessToken) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Layout>
            <Outlet />
        </Layout>
    );
}
